import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';

// 1. Import your new NotificationProvider
import { NotificationProvider } from './context/NotificationContext'; // Adjust path if necessary

import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';

// 2. Update the wrapper component to include the NotificationProvider
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  
  // If authenticated, wrap the children in NotificationProvider.
  // This ensures polling only happens for logged-in users.
  return isAuthenticated ? (
    <NotificationProvider>
      {children}
    </NotificationProvider>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes - No notification polling happens here */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Protected Routes - Notification polling starts when Dashboard loads */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}